import { Text, View, StyleSheet } from "@react-pdf/renderer";

const COL_ANCHO_1 = 20;
const COL_ANCHO_2 = 35;
const COL_ANCHO_3 = 10;
const styles = StyleSheet.create({
    tabla: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginTop: 10,
    },
    tablaFila: {
        margin: "auto",
        flexDirection: "row",
    },
    tablaColumna1: {
        width: COL_ANCHO_1 + "%",
        borderStyle: "solid",
        borderColor: "#000",
        borderBottomColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0                   
    },
    tablaColumna2: {
        width: COL_ANCHO_2 + "%",
        borderStyle: "solid",
        borderColor: "#000",
        borderBottomColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,                      
    },  
    tablaCeldaHeader: { 
        margin: 5,
        fontSize: 10,
        fontWeight: 500,
    },
    anchoColumna1:{
        width: COL_ANCHO_1 + "%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,  
    },
    anchoColumna2:{
        width: COL_ANCHO_2 + "%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },      
    anchoColumna3:{
        width: COL_ANCHO_3 + "%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,     
    },         
    tablaCelda: {
        margin: 5,
        fontSize: 10,
        textAlign: 'center',
        height: "auto",
        overflow: 'hidden',
        fontWeight: 800
    }, 
    tablaCeldaGray: {
        margin: 5,
        fontSize: 14,
        textAlign: 'center',
        height: "auto",
        overflow: 'hidden',
        fontWeight: 800,
        color: '#797D7F'
    }, 
    tablaCeldaGreen: {
        margin: 5,
        fontSize: 14,
        textAlign: 'center',
        height: "auto",
        overflow: 'hidden',
        color: 'green',
        fontWeight: 800
    }, 
    tablaCeldaRed: {
        margin: 5,
        fontSize: 14,
        textAlign: 'center',
        height: "auto",
        overflow: 'hidden',
        color: 'red',
        fontWeight: 800
    }, 
    tablaCeldaBlue: {
        margin: 5,
        fontSize: 14,
        textAlign: 'center',
        height: "auto",
        overflow: 'hidden',
        color: 'blue',
        fontWeight: 800
    }, 
});

export default function AuditoriaPrintDetalle({rows}) {
    return (
        rows.map((item, index) => (
                    <View key={index} style={styles.tablaFila}>
                        <View style={styles.anchoColumna1}>
                            <Text style={styles.tablaCelda}>{item.campo}</Text>
                        </View>
                        <View style={styles.anchoColumna2}>
                            <Text style={styles.tablaCelda}>{item.valorAntiguo}</Text>
                        </View>
                        <View style={styles.anchoColumna2}>
                            <Text style={styles.tablaCelda}>{item.valorNuevo}</Text>
                        </View>
                        <View style={styles.anchoColumna3}>
                            {(item.estado=="+") && <Text style={styles.tablaCeldaGreen}>{item.estado}</Text>}
                            {(item.estado=="-") && <Text style={styles.tablaCeldaRed}>{item.estado}</Text>}
                            {(item.estado=="!") && <Text style={styles.tablaCeldaBlue}>{item.estado}</Text>}
                            {(item.estado=="=") && <Text style={styles.tablaCeldaGray}>{item.estado}</Text>}
                        </View>
                    </View>                                                            
        ))    
)};


